/**
 * Environment-aware logger.
 * Logs errors in development, silent in production.
 * Replace with a service like Sentry for production error tracking.
 */
const isDev = process.env.NODE_ENV === 'development';

const logger = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};

export default logger;
